import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PopoverController } from '@ionic/angular';

@Component({
  selector: 'app-common-form-fields',
  templateUrl: './common-form-fields.component.html',
  styleUrls: ['./common-form-fields.component.scss'],
})
export class CommonFormFieldsComponent  implements OnInit {

  form!: FormGroup;

  status: any[] = [];
  priorities: any[] = [];

  @Input() onFormSubmitted!: (data: any) => void;

  constructor(
    private _fb: FormBuilder,
    private _popoverController: PopoverController
  ) { }

  ngOnInit() {
    this.form = this._fb.group({
      ownership: [""],
      status: [""],
      priority: [""]
    })
  }

  onSubmit() {
    this.onFormSubmitted(this.form.value);
    this._popoverController.dismiss();
  }

  checkAtLeastOneFieldSelected(): boolean {
    const ownership = this.form.get('ownership')?.value;
    const status = this.form.get('status')?.value;
    const priority = this.form.get('priority')?.value;

    return ownership || status || priority;
  }

  resetForm(){
    this.ngOnInit();  
  }

}
